const types = {
    CHANGE_PAGE: "CHANGE_PAGE",
}

export default types;
